module.exports = __webpack_public_path__ + "media/payment_networks/coinbase-0eac60ad.png";